<template>
  <div>
    <list
      row-key="LogId"
      ref="list"
      unit="操作日志"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.list"
      :delete-func="api.delete"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="菜单名称">
          <el-input size="mini" v-model="params.MenuName" placeholder="请输入菜单名称" />
        </el-form-item>
        <el-form-item label="操作人员">
          <el-input size="mini" v-model="params.EmpName" placeholder="请输入操作人员名称" />
        </el-form-item>
        <el-form-item label="操作类型">
          <el-input size="mini" v-model="params.OperType" placeholder="请输入操作类型" />
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.StartTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.EndTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="EmpName" label="操作人员" :width="$store.state.isMB?'110px':''" />
        <el-table-column prop="AddTime" label="操作时间" width="160px" />
        <el-table-column prop="OperType" label="操作类型" />
        <el-table-column prop="MenuName" label="功能菜单" min-width="90px" />
        <el-table-column prop="Ip" label="IP地址" min-width="90px" />
        <el-table-column prop="Title" label="信息标识" :min-width="$store.state.isMB?'150px':'250px'" show-overflow-tooltip />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import list from "@/components/common/list";
import listMixin from "@/mixins/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sy/log").default,
      params: {
        MenuName: "",
        UserName: "",
        StartTime: null,
        EndTime: null,
        OperType: "",
      },
    };
  },
};
</script>